import React from 'react';

const WhatsAppButton = () => {
  const phoneNumber = '919766875553';
  const message = encodeURIComponent('Hello Arvix Consulting, I would like to discuss a project.');
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-float"
      aria-label="Contact us on WhatsApp"
      data-testid="whatsapp-btn"
    >
      <i className="fab fa-whatsapp"></i>
    </a>
  );
};

export default WhatsAppButton;
